<template lang="html">
<div>
  <el-button type="primary" @click="$router.push('/home/saveCarExhibition')">发布新车展</el-button>

  <list-template actionUrl="carShow/carShowInfo/findCarShows.action" :queryParams="queryParams">
    <template slot="item" scope="scope">
      <el-card class="basic-margin" v-for="data in scope.datas">
        <el-row>
          <el-col :span="2">
            <img :src="imageUrl+data.showImg" style="width:100px;height:100px;">
          </el-col>

          <el-col :span="12">
            <h4><b>{{data.name}}</b> <el-tag type="success" size="mini" v-if="data.channelName" style="margin-left: 20px">{{data.channelName}}</el-tag></h4>
            <div>车展时间：{{data.startTime | dateFormat}} - {{data.endTime | dateFormat}}</div>

            <div style="color:#999999">累计投放 {{data.channelCount}} 家渠道 | 累计 {{data.businessCount}} 个商家参展，共 {{data.productCount}} 个商品</div>
            <div style="color:#999999">累计 {{data.numberOfParticipants?data.numberOfParticipants:0}} 人 | 浏览 {{data.browseCount?data.browseCount:0}} 次 | 产生 {{data.clueCount}} 条线索</div>

          </el-col>
          <el-col :span="9" style="text-align:right;">
            <el-button type="text" @click="$router.push({name:'修改车展信息', params: { id: data.id }})">修改车展</el-button>
            <el-button type="text" @click="$router.push({name:'车展详情', params: { carShowInfoId: data.id }})">查看详情</el-button>
          </el-col>

        </el-row>
      </el-card>
    </template>
  </list-template>

</div>
</template>

<script>
import ListTemplate from '@/components/ListTemplate'
import Config from '@/framework/configs/Config'
import BasicPager from '@/mixins/BasicPager'
export default {
  extend: BasicPager,
  data: function () {
    return {
      imageUrl: Config.imageUrl,
      datas: [],
      queryParams: {
        channelId: null
      }
    }
  },
  components: {
    ListTemplate
  },
  created () {
    if (this.loginInfo && this.loginInfo.loginPath == 'channel') {
      this.queryParams.channelId = this.loginInfo.id
    }
  }
}
</script>

<style lang="css">
</style>
